<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Re7X3y/tc-custom/9781646686056.jpg?1679071553749" alt="This image is the cover for the book Killer, The: Affairs of the State"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Killer, The: Affairs of the State
      </h1>
      <p class="bookDescription body article font2">
        <p>Caught and put to work as an on-call assassin for the French government, Killer has to adjust to working with a handler, his new partner Nicolas, a former special forces operative, and living life as a civilian. A network of city-wide corruption awaits, getting Killer even more involved in the midst of an escalating crisis, when he just wants to get back to his nihilistic lifestyle. But, as feeling for a coworker arise in his day job, will Killer be dangerously distracted, torn between two identities? Collects The Killer: Affairs of the State #1-6.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matz, Luc Jacamon
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      BOOM! Studios
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fc9868be